export const cities = [
  "Manchester", "Liverpool", "London", "Birmingham", "Leeds", "Sheffield",
  "Newcastle", "Brighton", "Bath", "Southampton", "Oxford", "Chester",
  "Stockport", "Stoke-on-Trent", "Essex", "Slough",
];

// Base nightly rate for a 1-bed apartment, and typical occupancy, by city
export const cityData = {
  London:          { nightly1: 175, occupancy: 0.82 },
  Brighton:        { nightly1: 150, occupancy: 0.78 },
  Oxford:          { nightly1: 150, occupancy: 0.78 },
  Bath:            { nightly1: 145, occupancy: 0.77 },
  Manchester:      { nightly1: 135, occupancy: 0.80 },
  Liverpool:       { nightly1: 115, occupancy: 0.76 },
  Birmingham:      { nightly1: 120, occupancy: 0.76 },
  Leeds:           { nightly1: 115, occupancy: 0.75 },
  Southampton:     { nightly1: 120, occupancy: 0.75 },
  Slough:          { nightly1: 120, occupancy: 0.76 },
  Newcastle:       { nightly1: 105, occupancy: 0.74 },
  Essex:           { nightly1: 115, occupancy: 0.74 },
  Chester:         { nightly1: 110, occupancy: 0.74 },
  Stockport:       { nightly1: 105, occupancy: 0.74 },
  Sheffield:       { nightly1: 100, occupancy: 0.73 },
  "Stoke-on-Trent":{ nightly1: 90,  occupancy: 0.72 },
};

export const bedroomMultiplier = {
  Studio: 0.82,
  "1 bed": 1.0,
  "2 beds": 1.45,
  "3 beds": 1.95,
  "4+ beds": 2.5,
};

export const propertyTypeAdjustment = {
  Apartment: 1.0,
  House: 1.08,
  Cottage: 1.05,
  Other: 1.0,
};

export const MANAGEMENT_FEE = 0.12; // + VAT
export const VAT = 0.20;
export const PLATFORM_FEE_BLENDED = 0.05; // blended OTA + direct booking

export function estimateNightly(city, beds, type) {
  const c = cityData[city] || cityData.Manchester;
  return Math.round(c.nightly1 * bedroomMultiplier[beds] * (propertyTypeAdjustment[type] || 1));
}

export function estimateOccupancy(city) {
  const c = cityData[city] || cityData.Manchester;
  return c.occupancy;
}

export function monthlyGross(nightly, occupancy) {
  return nightly * occupancy * 30;
}

export function netMonthly(gross) {
  const fee = MANAGEMENT_FEE * (1 + VAT); // 0.144
  return gross * (1 - fee - PLATFORM_FEE_BLENDED);
}

export function fmt(n) {
  return "£" + Math.round(n).toLocaleString();
}